// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const HideIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M12 3.48c-4.33 0-8.24 3.07-10.43 8.21q-.12.32 0 .61c.7 1.67 1.6 3.12 2.62 4.31l3.8-3.82q-.08-.38-.08-.79c0-2.28 1.84-4.13 4.1-4.13q.4 0 .78.07L16.2 4.5c-1.31-.66-2.74-1.01-4.2-1.01m10.44 8.21c-.94-2.2-2.2-4.05-3.69-5.41l-3.37 3.4c.44.66.7 1.47.7 2.32 0 2.28-1.83 4.13-4.08 4.13-.85 0-1.65-.27-2.3-.71L6.45 18.7c1.67 1.2 3.56 1.84 5.54 1.84H12c4.34 0 8.25-3.08 10.44-8.23q.12-.29 0-.6"
        opacity=".5"
      />
      <path d="M20.62 3.3c.3.3.3.8 0 1.1l-1.87 1.88-3.37 3.4-1.48 1.5.36-.37q.3.53.3 1.2c0 1.41-1.16 2.57-2.56 2.57q-.65 0-1.19-.3L4.46 20.7q-.24.23-.54.23t-.55-.23c-.25-.26-.3-.67-.09-.97l.03-.05 11-11.09 3.24-3.27.91-.92.06-.07.05-.06.96-.97c.3-.3.79-.3 1.09 0" />
    </g>
  </SvgIcon>
);

export default HideIcon;
